var _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrbit({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 159 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.916,
    cy: 79.916,
    r: 78,
    transform: "rotate(150 79.916 79.916)",
    stroke: "url(#orbit_svg__paint0_linear_2278_58172)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orbit_svg__paint0_linear_2278_58172",
    x1: 198.769,
    y1: 17.412,
    x2: 190.852,
    y2: 164.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#4C4F9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#1E1F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771,
    stopColor: "#51548B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202024"
  })))));
}

export default SvgOrbit;